
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1628_15147)","stroke":"#112A46","stroke-width":"1.5","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M9.382 2.59c.497-.538.746-.807 1.01-.964a2.07 2.07 0 012.068-.031c.268.149.524.41 1.037.933.512.524.768.785.914 1.06.351.66.34 1.462-.03 2.112-.155.27-.418.524-.945 1.031L7.167 12.77c-.998.962-1.498 1.443-2.122 1.687-.624.244-1.31.226-2.682.19l-.186-.005c-.418-.011-.627-.017-.748-.154-.121-.138-.105-.35-.072-.776l.018-.231c.094-1.198.14-1.796.374-2.335.234-.538.637-.975 1.444-1.849l6.19-6.706zM8.666 2.667l4.667 4.666"}}),_c('path',{attrs:{"d":"M9.333 14.666h5.334","stroke-linecap":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1628_15147"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    